import React from 'react';
import { FormattedMessage } from 'react-intl';

import { b } from 'utils/i18nUtils';
import { getHyperlink } from 'utils/linkUtils';

interface LoginTermsProps {
  confidentialityPolicyLink?: string;
  legalNotice?: string;
}

const LoginTerms: React.FC<LoginTermsProps> = ({ confidentialityPolicyLink, legalNotice }) => (
  <p className="text-center">
    {confidentialityPolicyLink && (
      <div className="mb-s">
        <FormattedMessage
          tagName="span"
          id="login.terms"
          defaultMessage="This <policy>Data Handling Policy</policy> outlines our practices for collecting, using, and protecting personal data."
          values={{
            policy: getHyperlink({
              href: confidentialityPolicyLink,
              'data-testid': 'confidentiality-policy',
              description: (
                <FormattedMessage
                  id="login.termsModal.description"
                  defaultMessage="You can access <b>{terms}</b> using the QR code or the URL below"
                  values={{
                    b,
                    terms: (
                      <FormattedMessage
                        id="login.termsModal.termsList.CONFIDENTIALITY_POLICY"
                        defaultMessage="the data handling policy"
                      />
                    ),
                  }}
                />
              ),
            }),
          }}
        />
      </div>)}
    {legalNotice && (
      <FormattedMessage
        id="login.termsModal.termsList.legalPolicy"
        defaultMessage="<a><b>Legal notice</b></a>"
        values={{ a: getHyperlink({ href: legalNotice, target: '_blank' }), b: (node) => b(node, 'text-s'), }}
        tagName="p"
      />)}
  </p>
);

export default LoginTerms;
